import React from 'react';
import { Row, Col, Typography, Input, DatePicker, Divider } from 'antd';
import dayjs from 'dayjs';

const { Title, Text } = Typography;

export default function InvoiceHeader({ invoiceData, values, setFieldValue, getInvoiceTypeLabel }) {
    if (!invoiceData) return null;

    return (
        <>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Title level={5} style={{ marginBottom: 16, paddingBottom: 8, borderBottom: '2px solid #f0f0f0' }}>
                        Data Invoice
                    </Title>
                </Col>
            </Row>

            <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <Text strong>Jenis Invoice</Text>
                    <Input
                        value={`BC. ${invoiceData.document_type || '16'} - Invoice ${getInvoiceTypeLabel()}`}
                        disabled
                        style={{ marginTop: 4, backgroundColor: '#f5f5f5' }}
                    />
                </Col>

                <Col xs={24} md={12}>
                    <Text strong>Nomor Invoice</Text>
                    <Input
                        value={values.invoiceNumber || ''}
                        onChange={(e) => setFieldValue('invoiceNumber', e.target.value)}
                        style={{ marginTop: 4 }}
                    />
                </Col>

                {/* Hidden per user request
                <Col xs={24} md={12}>
                    <Text strong>NOPEN</Text>
                    <Input
                        value={values.documentNumber || ''}
                        disabled
                        style={{ marginTop: 4, backgroundColor: '#f5f5f5' }}
                    />
                </Col>

                <Col xs={24} md={12}>
                    <Text strong>Tanggal NOPEN</Text>
                    <DatePicker
                        value={values.documentDate}
                        disabled
                        style={{ width: '100%', marginTop: 4, backgroundColor: '#f5f5f5' }}
                        format="DD MMMM YYYY"
                    />
                </Col>
                */}
            </Row>

            <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                <Col span={24}>
                    <Divider />
                    <Title level={5}>Detail Biaya & Layanan</Title>
                </Col>
            </Row>
        </>
    );
}
